import React, { useEffect, useState, useContext, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Chapters from "../../components/SatCourse/Chapters";
import { getChapters } from "../../services/SatCourseService";
// @ts-ignore
import ApiNames from "../../constants/ApiNames";
// @ts-ignore
import UrlNames from "../../constants/UrlNames";
// @ts-ignore
import UserContext from "../../utils/UserContext";
// @ts-ignore
import { NavigateToLanding } from "../../utils/CommonFunction";

export interface ChaptersScreenProps {
  token?: string;
  moduleIndex?: number;
  loaderStatus: (status: boolean) => void;
}

const ChaptersScreen: React.FC<ChaptersScreenProps> = (props) => {
  const {
    setSatChapters,
    subscriberId,
    setActiveIndex,
    checkRefresh,
    activeIndex,
  } = useContext<any>(UserContext);

  const useLocations = useLocation();
  const moduleId = useLocations.state?.id ? useLocations.state?.id : 1;
  const moduleIndex = useLocations.state?.index ? useLocations.state?.index : 0;

  const [isError, setError] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  const chaptersApiCall = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await getChapters(moduleId, subscriberId, props.token);
      if (response && response.status === 200) {
        setSatChapters(response.response || []);
      } else if (response && response.status !== 400) {
        setError("Error loading chapters");
        console.log("Response", response?.status);
      }
    } catch (error: any) {
      console.log(error);
      setError(error.message || "Error");
    } finally {
      setIsLoading(false);
      props.loaderStatus(true);
    }
  }, [moduleId, props, setSatChapters, subscriberId]);

  useEffect(() => {
    if (subscriberId) {
      chaptersApiCall();
      if (!checkRefresh) {
        setActiveIndex(moduleIndex);
      } else if (activeIndex !== props?.moduleIndex) {
        setActiveIndex(moduleIndex);
      }
    } else {
      NavigateToLanding();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moduleId]);

  const HAndleIndex = useCallback(
    (
      chaptersId: string | number,
      subTitle: string,
      about: string,
      progressPercent: number,
      index: number,
    ) => {
      navigate(UrlNames.topics, {
        state: {
          chaptersId: chaptersId,
          chapterIndex: index,
          title: subTitle,
          about: about,
          progressPercent: progressPercent,
          index: index,
          moduleId: moduleId,
          moduleIndex: moduleIndex,
        },
      });
    },
    [navigate, moduleId, moduleIndex],
  );

  return (
    <>
      <Chapters
        moduleId={moduleId}
        isError={isError}
        HAndleIndex={HAndleIndex}
        moduleIndex={moduleIndex}
        isLoading={isLoading}
      />
    </>
  );
};

export default ChaptersScreen;
